// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 1080 ? "Editor" : chunkId) + "." + {"1080":"5c0d126b","3292":"bc99f7f1","6777":"326aace1"}[chunkId] + ".chunk.css";
};